// services/vehicleStockService.js
import API_BASE from "../config/api";
export const fetchVehicleStockList = async (type = 1) => {

  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Vehicle/List?type=${type}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token
      }
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch vehicle stock");
  }

  return await response.json();
};